import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
@Pipe({
  name: 'dateRelativ',
  standalone: true,
})
export class DateRelativPipe implements PipeTransform {
  constructor() {
    dayjs.extend(relativeTime); // Erweitere dayjs um das relativeTime-Plugin
    dayjs.locale('de'); // Setze die Lokalisierung auf Deutsch
  }

  transform(value: Date | string | number): string {
    return dayjs(value).fromNow(); // Gibt die relative Zeit aus
  }
}
